import { render, staticRenderFns } from "./RelatedSubscriptionItem.vue?vue&type=template&id=022b6fea&scoped=true"
import script from "./RelatedSubscriptionItem.vue?vue&type=script&lang=js"
export * from "./RelatedSubscriptionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022b6fea",
  null
  
)

export default component.exports